const setGridFilterValue = (gridApi, setFilterValue) => {
  setFilterValue(gridApi.filterManager.quickFilter?.toLowerCase() || '');
};

export default setGridFilterValue;
